import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Select,
  Upload,
  Button,
  Row,
  Col,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import "./CreateEvent.scss";
import { postRequest, putRequest } from "../../../api/http";
import placementOfficer from "../../../api/placementOfficer";
import { LoadingView } from "../../common";
import toastr from "toastr";

const { Option } = Select;
const { Dragger } = Upload;

function CreateEvent() {
  const location = useLocation();
  const { event } = location.state || {};
  const [logoPreview, setLogoPreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const initialValues = event
    ? {
        name: event.name,
        description: event.description,
        eventType: event.eventType,
        venue: event.venue,
        startDate: moment(event.startDate),
        endDate: moment(event.endDate),
      }
    : {};

  console.log("eve", event);
  useEffect(() => {
    if (event) {
      setBannerPreview(event.bannerImageUrl);
      setLogoPreview(event.logoUrl);
    }
  }, []);

  const handleLogoChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj;
      setLogoPreview(URL.createObjectURL(file));
    } else {
      setLogoPreview(null);
    }
  };

  const handleBannerChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj;
      setBannerPreview(URL.createObjectURL(file));
    } else {
      setBannerPreview(null);
    }
  };
  const onFinish = async (values) => {
    try {
      setLoading(true);
      console.log("val", values);
      const eventData = {
        name: values.name,
        description: values.description,
        type: values.eventType,
        venue: values.venue,
        startDate: moment(values.startDate).format("YYYY-MM-DDTHH:mm"),
        endDate: moment(values.endDate).format("YYYY-MM-DDTHH:mm"),
      };

      const formData = new FormData();

      if (event) {
        formData.append(
          "input",
          new Blob([JSON.stringify(eventData)], { type: "application/json" }),
        );
      } else {
        formData.append(
          "data",
          new Blob([JSON.stringify(eventData)], { type: "application/json" }),
        );
      }
      if (values.banner && values.banner.length > 0) {
        const bannerBlob = await getImageBlob(values.banner[0]);
        formData.append("file", bannerBlob);
      }

      if (values.logo && values.logo.length > 0) {
        const logoBlob = await getImageBlob(values?.logo[0]);
        formData.append("logo", logoBlob);
      }

      let response = null;
      if (event) {
        response = await putRequest(
          placementOfficer.updateEvent(event.id),
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/mixed-stream",
            },
          },
        );
      } else {
        response = await postRequest(placementOfficer.createEvent(), formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/mixed-stream",
          },
        });
      }

      console.log("Event created successfully:", response.data);
      if (event) {
        toastr.success("Event has been updated successfully.");
      } else {
        toastr.success("Event has been created successfully");
      }
    } catch (error) {
      console.error("Error creating event:", error);
      if (event) {
        toastr.error("Failed to update event. Please try again later.");
      } else {
        toastr.error("Failed to create event. Please try again later.");
      }
    } finally {
      setLoading(false);
      navigate("/");
    }
  };

  const getImageBlob = async (fileObject) => {
    const file = fileObject.originFileObj;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const blob = new Blob([event.target.result], { type: file.type });
        resolve(blob);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  if (loading) return <LoadingView />;

  return (
    <div>
      <div className="header-events">
        {event ? (
          <h3 className="heading">Update Events!</h3>
        ) : (
          <h3 className="heading">Create Events!</h3>
        )}

        <Link className="btn ant-btn ant-btn-primary" to="/">
          Back
        </Link>
      </div>
      <div className="form-container">
        <Form
          form={form}
          name="create_event_form"
          onFinish={onFinish}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 24 }}
          initialValues={initialValues}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label="Event Name"
                name="name"
                rules={[
                  { required: true, message: "Please input event name!" },
                  { max: 70, message: "Name should not exceed 70 characters" },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                className="bold-label"
              >
                <Input placeholder="Event Name" />
              </Form.Item>

              <Form.Item
                label="Description"
                name="description"
                rules={[
                  { required: true, message: "Please input Description!" },
                  {
                    max: 500,
                    message: "Description should not exceed 500 characters",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                className="bold-label"
              >
                <TextArea style={{ height: 100 }} placeholder="Description" />
              </Form.Item>

              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    label="Event Type"
                    name="eventType"
                    rules={[
                      { required: true, message: "Please select event type!" },
                    ]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="bold-label"
                  >
                    <Select placeholder="Select event type">
                      <Option value="JOB_DRIVE">JOB DRIVE</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Location"
                    name="venue"
                    rules={[{ required: true, message: "Please input Venue!" }]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="bold-label"
                  >
                    <Input placeholder="Location" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    label="Start Date & Time"
                    name="startDate"
                    rules={[
                      {
                        required: true,
                        message: "Please select start date and time!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, startDate) {
                          const endDate = getFieldValue("endDate");
                          const currentDate = moment().startOf("minute");
                          if (
                            !endDate ||
                            !startDate ||
                            startDate.isBefore(endDate)
                          ) {
                            if (!event) {
                              if (startDate.isSameOrAfter(currentDate)) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(
                                  new Error(
                                    "Start date must be after the current date and time",
                                  ),
                                );
                              }
                            } else {
                              return Promise.resolve();
                            }
                          }
                          return Promise.reject(
                            new Error(
                              "Start date must be before the end date ",
                            ),
                          );
                        },
                      }),
                    ]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="bold-label"
                  >
                    <DatePicker
                      format="DD-MM-YYYY, HH:mm"
                      showTime={{
                        defaultValue: moment(),
                        hideDisabledOptions: true,
                      }}
                      disabledDate={(current) =>
                        current && current < moment().startOf("day")
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="End Date & Time"
                    name="endDate"
                    rules={[
                      {
                        required: true,
                        message: "Please select end date and time!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, endDate) {
                          const startDate = getFieldValue("startDate");
                          const now = moment().startOf("minute");
                          if (
                            !startDate ||
                            !endDate ||
                            startDate.isBefore(endDate)
                          ) {
                            // Check if the end date is after the start date
                            if (endDate.isSameOrAfter(now)) {
                              // Check if the end date is after the current date and time
                              return Promise.resolve();
                            } else {
                              return Promise.reject(
                                new Error(
                                  "End date must be after the current date and time",
                                ),
                              );
                            }
                          }
                          return Promise.reject(
                            new Error("End date must be after the start date"),
                          );
                        },
                      }),
                    ]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="bold-label"
                  >
                    <DatePicker
                      format="DD-MM-YYYY, HH:mm"
                      showTime={{
                        defaultValue: moment(),
                        hideDisabledOptions: true,
                      }}
                      disabledDate={(current) =>
                        current &&
                        (current < moment().startOf("day") ||
                          current >
                            moment(form.getFieldValue("startDate")).add(
                              31,
                              "days",
                            ))
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <span>
                        Logo&nbsp;
                        <span style={{ color: "#888", fontWeight: "lighter" }}>
                          (Square image • Recommended: 512×512 • Maximum 5MB)
                        </span>
                      </span>
                    }
                    name="logo"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="bold-label"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (!e || !e.fileList) {
                        return [];
                      }
                      return Array.isArray(e.fileList)
                        ? e.fileList
                        : [e.fileList];
                    }}
                  >
                    <Upload
                      name="logo"
                      listType="picture"
                      multiple={false}
                      beforeUpload={(file) => {
                        const isImage = file.type.startsWith("image/");
                        const isLessThan5MB = file.size / 1024 / 1024 < 5;

                        if (!isImage) {
                          toastr.error("Only image files are allowed.");
                          return Upload.LIST_IGNORE;
                        }

                        if (!isLessThan5MB) {
                          toastr.error("Image must be smaller than 5MB.");
                          return Upload.LIST_IGNORE;
                        }

                        return false;
                      }}
                      onChange={handleLogoChange}
                      accept="image/png,image/jpeg,image/jpg,image/webp"
                    >
                      <Button icon={<InboxOutlined />}>Upload Logo</Button>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <span>
                        Banner&nbsp;
                        <span style={{ color: "#888", fontWeight: "lighter" }}>
                          (Wide image • Recommended: 1200×400 • Maximum 5MB)
                        </span>
                      </span>
                    }
                    name="banner"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    className="bold-label"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (!e || !e.fileList) {
                        return [];
                      }
                      return Array.isArray(e.fileList)
                        ? e.fileList
                        : [e.fileList];
                    }}
                  >
                    <Upload
                      name="banner"
                      listType="picture"
                      multiple={false}
                      beforeUpload={(file) => {
                        const isImage = file.type.startsWith("image/");
                        const isLessThan5MB = file.size / 1024 / 1024 < 5;

                        if (!isImage) {
                          toastr.error("Only image files are allowed.");
                          return Upload.LIST_IGNORE;
                        }

                        if (!isLessThan5MB) {
                          toastr.error("Image must be smaller than 5MB.");
                          return Upload.LIST_IGNORE;
                        }

                        return false;
                      }}
                      onChange={handleBannerChange}
                      accept="image/png,image/jpeg,image/jpg,image/webp"
                    >
                      <Button icon={<InboxOutlined />}>Upload Banner</Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Form.Item wrapperCol={{ offset: 0, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default CreateEvent;
